// extracted by mini-css-extract-plugin
module.exports = {"datasetSchemasToolbar":"DatasetSchemas_datasetSchemasToolbar__3UaUB","index":"DatasetSchemas_index__3xxZ0","positioning":"DatasetSchemas_positioning___pfGt"};